import AsyncSelect from 'react-select/async';
import { MultiValue } from 'react-select';
import { SearchType } from '../../../data/__generated__/globalTypes';
import React from 'react';
import { useForecastingSettings } from '../../ForecastingContextProvider';
import { usePrimaryForecastingState } from '../ForecastingPanel';
import { selectDefaults, useAutoCompleteOptions, useForecastingFilterValidation } from './ForecastingFilters';
import ErrorTooltip from '../ErrorTooltip';
import { ReactComponent as LoadingState } from 'svg/loader.svg';


export default function Country() {
    const { forecastingSettings, updateForecastingSetting } = useForecastingSettings();
    const { isPrimaryForecastingLoading } = usePrimaryForecastingState();
    const loadOptions = useAutoCompleteOptions(SearchType.COUNTRY);
    const { loading, data } = useForecastingFilterValidation(SearchType.COUNTRY);

    let tooltip = null;
    if (loading) {
        tooltip = <LoadingState className='inline-flex CampaignSpendOverlayLoadingState h-4 w-4 ml-1' />;
    } else {
        if (data?.filterDependencyValidation) {
            tooltip = (
                <ErrorTooltip id={'country-error-tooltip'}>
                    <div>
                        The selected countries are no longer valid. They may not be available for the selected SSPs.
                    </div>
                </ErrorTooltip>
            );
        }
    }

    return (
        <div className='mt-4 w-80'>
            <div style={{flexDirection: 'row'}}>
                <label
                    htmlFor='country'
                    className='inline-block text-sm font-medium text-gray-700'
                >
                    Country
                </label>
                {tooltip}
            </div>
            <AsyncSelect
                key={'country:' + JSON.stringify(forecastingSettings)}
                isDisabled={isPrimaryForecastingLoading}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                isMulti
                name='countries'
                className='basic-multi-select'
                classNamePrefix='select'
                onChange={(newValue: MultiValue<{
                    label: string,
                    value: string
                }>) => updateForecastingSetting({ countryFilter: newValue.map(c => c.value) })}
                defaultOptions
                loadOptions={loadOptions}
                defaultValue={selectDefaults(forecastingSettings.countryFilter)}
            />
        </div>
    );
}
